import axios from "axios";

// const baseURL = "https://hctest.codelynks.in/"; // dev & qa
const baseURL = "https://chavadihc.codelynks.in/" // production


const Axioscall = axios.create({
  baseURL: baseURL,
});

Axioscall.interceptors.request.use(function (config) {
  const token = localStorage.getItem("x-access-token");
  config.headers.Authorization = token ? `${token}` : "";
  return config;
});

export default Axioscall;
export { baseURL };
